export const GENERIC_UPLOAD_OWNER_TYPES = [
  "company",
  "product",
  "order",
  "lead",
  "user",
  "supportRequest",
] as const;

export const FILE_OWNER_TYPES = [
  ...GENERIC_UPLOAD_OWNER_TYPES,
  "supportProject",
] as const;
